const tipoGestaoPatrimonialList = [
    {
        id: 'VISAO', // HARDCODE.idTipoGestaoPatrimonialVisao
        descricao: 'Visão',
        ordem: 10,
    },
    {
        id: 'ESTRAT', // HARDCODE.idTipoGestaoPatrimonialEstrategia
        descricao: 'Estratégia',
        ordem: 20,
    },
    {
        id: 'PLANEJ', // HARDCODE.idTipoGestaoPatrimonialPlanejamento
        descricao: 'Planejamento',
        ordem: 30,
    },
]

export default tipoGestaoPatrimonialList